{
  "address-selection--no-option": "No, use a new address",
  "address-selection--yes-option": "Yes, use",
  "address-selection--update-aria-label": "Update address",
  "dates--default-label": "Date",
  "form-download--error-message": "Something went wrong on our end. We’re not able to download a copy of your VA Form %s (PDF).",
  "form-download--link-text": "Download a copy of your VA Form %s",
  "form-download--loading-message": "Preparing your form for download...",
  "form-download--loading-label": "Loading form data...",
  "review--no-option": "No",
  "validation--date-range": "End date must be after the start date",
  "validation--date-range--future": "Date may not be more than 1 year from today",
  "validation--date-value--current": "Enter a valid current or past date",
  "validation--date-value--invalid": "Enter a valid date",
  "validation--required": "You must provide a response",
  "validation--text-characters--singular": "You entered a character we can’t accept. Remove this character",
  "validation--text-characters--plural": "You entered multiple characters we can’t accept. Remove these characters",
  "validation--total-file-size": "Adding this file exceeds the total upload limit of %s. Remove a file or upload a smaller one."
}
